import { gql } from "@apollo/client"; import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState, useMemo, useCallback } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ErrorDialog from '../../../components/ErrorDialog';
import { Outlet } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_USUARIOS_PAGINADOS } from '../../../data/graphQL/queries/usuarios/getUsuariosPaginados';
import { adaptUserArray } from '../../../adapters/users/allUsersAdapter';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { useDebounce } from '../../../hooks/useDebounce';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { TextInput } from '../../../components/textInput/TextInput';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export default function UsuariosAdminAll({ setChildrenAction }) {

  const [openDlg, setOpenDlg] = useState(false);
  const [loadingHabilitar, setLoadingHabilitar] = useState(false);
  const [usuarioConsultado, setUsuarioConsultado] = useState({
    id: 0,
    apellido: '',
    nombre: '',
    usuario: ''
  });
  const [opcionConsultada, setOpcionConsultada] = useState(false);

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const QGetUsuariosNH = gql`
        query QGetUsuariosAll ($opcion: Int!) {
            usuariosAll (opcion: $opcion)
                {
                    success,
                    error,
                    valorEsperado {
                        idUsuario,
                        usuario,
                        nombre,
                        apellido,
                        email,
                        idUsuarioAuth,
                        activo
                    }
                }
        }`;

  const {
    userRows,
    totalCount,
    orderBy,
    setOrderBy,
    filters,
    handleChangeFilters,
    usersLoading,
    setPaginationStatus,
    paginationStatus
  } = useGetAllUsers();

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  useEffect(() => {
    setChildrenAction(() =>
      <div>
        <CustomButton
          onClick={handleNuevo}>
          {t("nuevo")}
        </CustomButton>
      </div>
    );
  }, [setChildrenAction]);

  const handleEdit = (row) => {
    navigate('/usuarioadmin/' + row.idUsuario, { state: { usuario: row, edit: true } });
  };

  const handleNuevo = () => {
    navigate('/usuarioadmin/0', { state: { usuario: null, edit: false } });
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 4,
      renderCell: ({ row }) => {
        return (
          <PopoverModal>
            <div className='popover-modal-content'>
              <div onClick={() => handleEdit(row)} aria-hidden='true' className='item-option clickable-option'>
                <EditIcon className='edit-icon' />
                <span className='toggle-action'>Editar</span>
              </div>
              <div className='item-option'>
                <span className='toggle-action'>Activo</span>
                <SwitchInput
                  onChange={(e) => {
                    handleHabilitar(row, e.target.checked);
                  }}
                  checked={row?.activo} />

              </div>
            </div>
          </PopoverModal>);

      }
    },
    { field: 'idUsuario', headerName: 'Id', flex: 8 },
    { field: 'usuario', headerName: 'Usuario', flex: 12 },
    { field: 'apellido', headerName: 'Apellido', flex: 14 },
    { field: 'nombre', headerName: 'Nombre', flex: 14 },
    { field: 'email', headerName: 'Email', flex: 24 },
    { field: 'activo', type: 'boolean', headerName: 'Activo', flex: 8 },
    { field: 'idUsuarioAuth', type: 'boolean', headerName: 'Auth', flex: 8 }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  const memoSortModel = useMemo(() =>
    orderBy?.fieldName ? [{ field: orderBy.fieldName, sort: orderBy.order?.toLowerCase() }] : [],
    [orderBy?.fieldName, orderBy?.order]);

  const MSaveUsuarioHabilitado = gql`
    mutation MSaveUsuarioHabilitado( $model: SaveUsuarioHabilitadoModelInput!){
        saveUsuarioHabilitado (model: $model) 
        {
            success,
            error,
            valorEsperado
        }
      }`;

  const [saveUsuarioHabilitado, { loadingHab, errorHab, datosHab }] = useMutation(MSaveUsuarioHabilitado, {
    onCompleted: (datosHab) => {
      if (datosHab.saveUsuarioHabilitado.success) {
        toast.success("Estado del Usuario grabado correctamente!");
        setLoadingHabilitar(false);
        setOpenDlg(false);
      } else if (datosHab.saveUsuarioHabilitado.error === 'ERRORDB' || parseInt(datosHab.saveUsuarioHabilitado.error, 10) > 0) {
        setMensajeError(datosHab.saveUsuarioHabilitado.error);
        return false;
      }
    },
    onError: (datosHab) => {
      setOpenDlg(false);
      setLoadingHabilitar(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleHabilitar = (row, opcion) => {
    setUsuarioConsultado(row);
    setOpcionConsultada(opcion);
    setOpenDlg(true);
  };

  const handleAceptarHabilitar = () => {
    // si no está vinculado muestro el mensaje informativo y redirecciono a la edición del usuario para que complete
    // todo el proceso
    if (opcionConsultada && usuarioConsultado.idUsuarioAuth <= 0) {
      toast.error("El usuario no se encuentra vinculado y será redireccionado a la edición del mismo para completar todo el proceso y habilitarlo.");
      handleEdit(usuarioConsultado);
    } else {
      setLoadingHabilitar(true);
      saveUsuarioHabilitado({ variables: { model: { idUsuario: usuarioConsultado.idUsuario, habilitado: opcionConsultada } } });
    }
  };

  const handleCancelarHabilitar = () => {
    setUsuarioConsultado({});
    setOpcionConsultada(false);
    setOpenDlg(false);
  };

  const onPageChange = useCallback((page) => {
    setPaginationStatus((prev) => ({ ...prev, page }));
  }, [setPaginationStatus]);

  const onPageSizeChange = useCallback((pageSize) => {
    setPaginationStatus((prev) => ({ ...prev, pageSize, page: 0 }));
  }, [setPaginationStatus]);

  return (
    <>
      <div style={{ width: '100%' }}>
        <Grid container direction="row" spacing={2}>
          <Grid size={4.5}>
            <TextInput
              onChange={(e) => handleChangeFilters('searchFilter', e.target.value)}
              value={filters?.searchFilter}
              onClearButtonClick={() => handleChangeFilters('searchFilter', '')}
              placeholder="Filtrar usuarios"
              searchIcon />

          </Grid>
          <Grid size="grow">
            <Box sx={{ display: 'flex' }}>
              <ButtonOptionGroup
                options={['Activos', 'Inactivos', 'Todos']}
                onOptionClick={(value) => handleChangeFilters('selectedFilter', value)}
                selectedOption={filters?.selectedFilter} />

            </Box>
          </Grid>
        </Grid>
      </div>
      <br />

      <DataGridGenerico
        columns={columns}
        fileNameExport='Usuarios'
        rows={userRows}
        loading={usersLoading}
        toolbar={false}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSize={paginationStatus.pageSize}
        totalCount={totalCount}
        currentPage={paginationStatus.page}
        onSortModelChange={(model) => setOrderBy({ fieldName: model[0]?.field, order: model[0]?.sort?.toLowerCase() })}
        sortModel={memoSortModel} />

      <Outlet />

      <CustomDialog
        maxWidth="md"
        open={openDlg}
        title={'Estado de usuario'}
        onCancel={handleCancelarHabilitar}
        onAccept={handleAceptarHabilitar}>

        <span>
          ¿Confirma que desea <strong>{opcionConsultada ? "habilitar" : "deshabilitar"}</strong> el usuario de <strong>{usuarioConsultado.nombre} {usuarioConsultado.apellido} ({usuarioConsultado.usuario})</strong>?.<br /><br />
        </span>
      </CustomDialog>
      <ErrorDialog
        id="dlg-error-terminos"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


    </>);


}

const useGetAllUsers = () => {
  const [usersData, setUsersData] = useState();
  const [orderBy, setOrderBy] = useState({
    fieldName: 'idUsuario',
    order: 'DESC'
  });
  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      searchFilter: '',
      selectedFilter: 0
    },
    'usuariosFilters'
  );

  const {
    searchFilter,
    selectedFilter
  } = filters;

  const debouncedFilterValue = useDebounce(searchFilter, 1000);
  const [getAllUsuarios, { data: allUsuariosData, loading: usersLoading }] = useLazyQuery(GET_USUARIOS_PAGINADOS, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!allUsuariosData) return;
    setUsersData(allUsuariosData);
  }, [allUsuariosData]);

  useEffect(() => {
    getAllUsuarios({
      variables: {
        skip: paginationStatus.page * paginationStatus.pageSize,
        take: paginationStatus.pageSize,
        where: {
          or: [
            ...[!!parseInt(debouncedFilterValue?.trim(), 10) ? { idUsuario: { eq: parseInt(debouncedFilterValue?.trim(), 10) } } : {}],
            { usuario: { contains: debouncedFilterValue?.trim() } },
            { apellido: { contains: debouncedFilterValue?.trim() } },
            { nombre: { contains: debouncedFilterValue?.trim() } },
            { email: { contains: debouncedFilterValue?.trim() } }],

          and: [
            selectedFilter < 2 ? { activo: { eq: !Boolean(selectedFilter) } } : {}]

        },
        order: [{
          [orderBy?.fieldName]: orderBy?.order?.toUpperCase()
        }]
      }
    });
  }, [paginationStatus, selectedFilter, debouncedFilterValue, orderBy]);

  return {
    userRows: adaptUserArray(usersData) || [],
    totalCount: usersData?.allUsuarios?.totalCount,
    orderBy,
    setOrderBy,
    filters,
    handleChangeFilters,
    usersLoading,
    setPaginationStatus,
    paginationStatus
  };
};